<script>
import Layout from '@/Shared/Layout'
export default {
  layout: Layout,
}
</script>
<script setup>
import { onMounted, onUnmounted } from 'vue'

const props = defineProps({
  myProducts: Array,

})

const extractYoutube = () => {
  let t = []
  const l = props.myProducts.filter(i => i.productYt2 != '')
  l.forEach((e) => { 
    if (e.productYt2 != '' ){
      const s = e.productYt2.split(',')
      s.forEach( (se)=>{
        if ( !t.includes(se) ) t.push(se)
      })
    }
  })
  return t
}
const extractVimeo = () => {
  let t = []
  const l = props.myProducts.filter(i => i.productYt1 != '')
  l.forEach((e) => {
    if (e.productYt1 != '') {
      const s = e.productYt1.split(',')
      s.forEach((se) => {
        if (!t.includes(se)) t.push(se)
      })
    }
  })
  return t
}

const hasVideo = () => {
  const num = extractVimeo().length + extractYoutube().length
  const r = (num >= 1) ? true : false
  return r
}

onMounted(() => {
  // console.log(props.myProducts)
  // console.log(extractVimeo())
})
onUnmounted(() => { })
</script>
<template>
  <div v-if="hasVideo()" class="header-videos">
    <template v-if="extractVimeo().length >= 1">
      <div
        v-for="v in extractVimeo()"
        :key="v" class="vimeo-wrap brand-video"
      >
        <iframe
          :src="'https://player.vimeo.com/video/' + v"
          frameborder="0"
          width="100%"
          height="100%" allowfullscreen
        />
      </div>
    </template>
    <template v-if="extractYoutube().length >= 1">
      <div
        v-for="v in extractYoutube()"
        :key="v"
        class="youtube-wrap brand-video"
      >
        <iframe
          :src="'https://www.youtube.com/embed/' + v"
          frameborder="0"
          width="100%"
          height="100%"
          allowfullscreen
        />
      </div>
    </template>
  </div>
</template>
